function scrollTo({ el, offset = 0, mobileOnly = false, maxWidth = 1180 }: {
  el: string
  offset?: number
  mobileOnly?: boolean
  maxWidth?: number
}) {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return
  }
  if (mobileOnly && window.innerWidth >= maxWidth) {
    return
  }
  const element = document.getElementById(el.replace('#', ''))
  if (!element) {
    return
  }
  const y = element.getBoundingClientRect().top + window.scrollY
  window.scrollTo({ top: y + offset, behavior: 'smooth' })
}

export const useScrollTo = scrollTo
